import React from 'react'

export class SessionReducer extends React.Component {

    /*
    constructor(props) {
        super(props)
        this.onLogoutActionConfirmed = this.onLogoutActionConfirmed.bind(this)
    }

    onLogoutActionConfirmed() {
        const {
            dispatch,
            storeTarget,
            storeTargetPopups
        } = this.props
        dispatch(actionTarget(sessionInvalidate(), storeTarget))
    }
    */
   
    render() {
        const {
            children
        } = this.props
        return children ? React.Children.only(children) : null
    }
}
